import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import downloadImage from "../../../common/images/download.svg";
import { downloadFile } from "../../../common/utils/downloadFile";
import { format } from "date-fns";
import { TertiaryTableRow } from "@hatch-digital-nl/abs-storybook/legacy";

export const mapEstablishmentCertificatesToRows = (
    certificates: CertificateInterface[],
): TertiaryTableRow[] => {
    return certificates.map((certificate) => {
        return {
            id: certificate.id,
            columns: [
                { value: format(certificate.valid_at, "dd-MM-yyyy") },
                {
                    value: certificate?.expires_at
                        ? format(certificate.expires_at, "dd-MM-yyyy")
                        : "Geen geldigheidsduur",
                },
                {
                    value: certificate.certificate_file.file_url
                        ? "Download"
                        : "Geen certificaat geüpload",
                    iconUrl: downloadImage,
                    onLinkClick: certificate.certificate_file.file_url
                        ? () =>
                              downloadFile(
                                  certificate.certificate_file.file_url,
                                  certificate.certificate_file.file_name,
                              )
                        : undefined,
                },
            ],
        };
    });
};
